/** 分类tab-收藏 */
export enum NS {
  /** 收藏 */
  Favorites = 'favorites'
}
